import { z } from "zod";

export const invoiceTypeEnum = z.enum(["INVOICE", "REFUND_INVOICE"]);

export type InvoiceType = z.infer<typeof invoiceTypeEnum>;
